module.exports = __webpack_public_path__ + "static/media/CircleCheck.cebebd62.svg";